var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDeleteBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_7284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.55583 16C3.06694 16 2.64857 15.8261 2.30072 15.4782C1.95286 15.1304 1.77864 14.7117 1.77805 14.2222V2.66667H0.88916V0.888889H5.3336V0H10.6669V0.888889H15.1114V2.66667H14.2225V14.2222C14.2225 14.7111 14.0486 15.1298 13.7007 15.4782C13.3529 15.8267 12.9342 16.0006 12.4447 16H3.55583ZM5.3336 12.4444H7.11138V4.44444H5.3336V12.4444ZM8.88916 12.4444H10.6669V4.44444H8.88916V12.4444Z",
    fill: "#E6332A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_7284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeleteBin);
export default __webpack_public_path__ + "static/media/ic-delete-bin.6023098775592c0f39a336a3a870743d.svg";
export { ForwardRef as ReactComponent };